/* GutNaturals scroll-reveal.
   Auto-targets content inside section.gn so individual sections need no markup
   changes: direct children of .gn__wrap animate in, and grid/list containers
   stagger their children. Add data-gn-no-reveal to a section to opt it out.

   Guarded on window.__gnRevealInit because this file is referenced once per GN
   section, so the tag can appear many times on one page.

   FAILSAFE: content must never be left invisible. Three layers protect that -
   (1) the hidden state only exists while <html> carries .gn-reveal-on, which
   only this script adds; (2) prefers-reduced-motion and missing
   IntersectionObserver both bail before that class is added; (3) if the
   observer has still not delivered a single callback after 4s (background tab,
   suspended rendering, some embedded webviews), the effect is switched off
   entirely and everything is shown. */
(function(){
  if (window.__gnRevealInit) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  window.__gnRevealInit = true;

  var html = document.documentElement;
  html.classList.add('gn-reveal-on');

  var STAGGER = '[class*="__grid"],[class*="__steps"],[class*="__stats"],[class*="__points"],.tr__col,.cp__scroll';
  var io, everFired = false;

  function abort(){
    html.classList.remove('gn-reveal-on');
    if (io) io.disconnect();
  }

  function mark(el, delay){
    if (el.hasAttribute('data-gn-reveal')) return;
    el.setAttribute('data-gn-reveal','');
    if (delay) el.style.transitionDelay = delay + 'ms';
  }

  function scan(root){
    var scope = (root && root.querySelectorAll) ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('section.gn'), function(sec){
      if (sec.hasAttribute('data-gn-no-reveal')) return;
      var wrap = sec.querySelector('.gn__wrap');
      if (wrap){
        Array.prototype.forEach.call(wrap.children, function(child, i){
          mark(child, Math.min(i * 80, 320));
        });
      }
      Array.prototype.forEach.call(sec.querySelectorAll(STAGGER), function(grid){
        Array.prototype.forEach.call(grid.children, function(child, i){
          mark(child, Math.min(i * 70, 420));
        });
      });
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-gn-reveal]:not(.is-in)'), function(el){
      io.observe(el);
    });
  }

  function init(){
    io = io || new IntersectionObserver(function(entries){
      everFired = true;
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    scan(document);

    /* If nothing has been observed successfully by now, show everything. */
    setTimeout(function(){ if (!everFired) abort(); }, 4000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function(e){ if (io) scan(e.target); });
})();
